<template>
  <div class="title-header-bar">
    <div class="title-header-bar-word">{{title}}</div>
    <img src="../../../static/images/common/title-bar.jpg" />
  </div>
</template>

<script>
  export default {
    props: {
      title: String
    }
  }
</script>

<style scoped lang="less">
  .title-header-bar {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      vertical-align: middle;
    }

    .title-header-bar-word {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 36px;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/title-bar.vue